import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const PlanningIcon: React.FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      {...props}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.87971 7.35233C8.01077 6.27682 9.58504 5.77539 11.3782 5.77539L20.7571 5.77539C22.5543 5.77539 24.1294 6.27644 25.2589 7.35316C26.395 8.43639 26.9602 9.98796 26.9552 11.8427L26.9552 19.2304C26.9552 20.1632 26.5948 21.0592 25.9485 21.7327L20.9728 26.9157C20.2915 27.6243 19.3506 28.0271 18.3656 28.0271L11.3782 28.0271C9.57949 28.0271 8.00322 27.5119 6.87325 26.4164C5.73874 25.3165 5.17053 23.7443 5.17053 21.8661L5.17053 11.8418C5.17053 9.98557 5.74158 8.43457 6.87971 7.35233ZM8.15189 8.69018C7.46113 9.34702 7.01669 10.3677 7.01669 11.8418L7.01669 21.8661C7.01669 23.3709 7.46397 24.4176 8.15835 25.091C8.85726 25.7685 9.9233 26.181 11.3782 26.181L18.3656 26.181C18.8465 26.181 19.307 25.9845 19.6414 25.6367L24.6163 20.4547C24.9329 20.1247 25.109 19.6864 25.109 19.2304L25.109 11.8418L25.109 11.8391C25.1133 10.3644 24.6726 9.34489 23.9849 8.68936C23.2902 8.02701 22.2231 7.62154 20.7571 7.62154L11.3782 7.62154C9.91776 7.62154 8.84973 8.02662 8.15189 8.69018Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3493 18.9434L22.3517 18.9434L25.9466 18.9434C26.4565 18.9434 26.8696 19.3567 26.8696 19.8664C26.8696 20.3762 26.4565 20.7895 25.9466 20.7895L22.353 20.7895C21.0093 20.7936 19.9221 21.8837 19.9229 23.2273L19.9229 27.024C19.9229 27.5338 19.5096 27.9471 18.9999 27.9471C18.4901 27.9471 18.0768 27.5338 18.0768 27.024L18.0768 23.2282C18.0768 23.2283 18.0768 23.228 18.0768 23.2282C18.0756 20.865 19.9885 18.9495 22.3493 18.9434Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3942 14.1262C10.3942 13.6164 10.8074 13.2031 11.3172 13.2031L19.4855 13.2031C19.9952 13.2031 20.4085 13.6164 20.4085 14.1262C20.4085 14.6359 19.9952 15.0492 19.4855 15.0492L11.3172 15.0492C10.8074 15.0492 10.3942 14.6359 10.3942 14.1262ZM10.3942 19.1431C10.3942 18.6334 10.8074 18.2201 11.3172 18.2201L14.9061 18.2201C15.416 18.2201 15.8292 18.6334 15.8292 19.1431C15.8292 19.6529 15.416 20.0662 14.9061 20.0662L11.3172 20.0662C10.8074 20.0662 10.3942 19.6529 10.3942 19.1431Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5936 4.02539C12.1034 4.02539 12.5167 4.43867 12.5167 4.94847L12.5167 8.59369C12.5167 9.10348 12.1034 9.51676 11.5936 9.51676C11.0838 9.51676 10.6705 9.10348 10.6705 8.59369L10.6705 4.94847C10.6705 4.43867 11.0838 4.02539 11.5936 4.02539ZM20.5427 4.02539C21.0525 4.02539 21.4658 4.43867 21.4658 4.94847L21.4658 8.59369C21.4658 9.10348 21.0525 9.51676 20.5427 9.51676C20.0329 9.51676 19.6197 9.10348 19.6197 8.59369L19.6197 4.94847C19.6197 4.43867 20.0329 4.02539 20.5427 4.02539Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default PlanningIcon;
